/** Flip via REACT_APP_ENABLE_SSO_LOGIN=true to show Google/Microsoft on the login page. */
export const SSO_LOGIN_ENABLED =
  process.env.REACT_APP_ENABLE_SSO_LOGIN === "true";
